const ACTIONS = {
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
  TOGGLE_HELP: 'TOGGLE_HELP',
};

function addFeedback(id, msg, icon) {
  return { type: ACTIONS.SHOW_NOTIFICATION, payload: { id, msg, icon } };
}
function dissmissFeedback(id) {
  return { type: ACTIONS.HIDE_NOTIFICATION, payload: id };
}

let next_id = 0;
function showFeedback(msg, sticky = false, icon = false) {
  return function(dispatch, getState) {
    // *
    const id = next_id++;
    dispatch(addFeedback(id, msg, icon));

    if (!sticky) {
      setTimeout(() => {
        dispatch(dissmissFeedback(id));
      }, 6000);
    }
  };
}

export default {
  dissmissFeedback,
  showFeedback,
};

export { uiReducer };

const initialState = {
  notifications: [],
};

function uiReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ACTIONS.SHOW_NOTIFICATION:
      const notification = {
        id: action.payload.id,
        msg: action.payload.msg,
        icon: action.payload.icon,
      };
      return {
        ...state,
        notifications: [...state.notifications, { ...notification }],
      };

    case ACTIONS.HIDE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(n => n.id !== action.payload),
      };
    default:
      return state;
  }
}

/*
  Unlike in a regular action creator, we can exit early in a thunk
    Redux doesn’t care about its return value (or lack of it)
    if (!getState().areNotificationsEnabled) {
      return
    }
 */
